import { useInView } from "react-intersection-observer";
import { useGetUsersAsAdminQuery } from "../../../../lib/apollo/graphql/generated";
import { useState } from "react";

function useUsersContainer() {
  const { ref: fetchMoreRef } = useInView({
    threshold: 0.2,
    onChange: onEndReached,
  });

  const [fetchingMore, setFetchingMore] = useState(false);

  const { loading, data, fetchMore } = useGetUsersAsAdminQuery({
    variables: {
      first: 20,
    },
  });

  function onEndReached(inView: boolean) {
    if (
      inView &&
      !fetchingMore &&
      data?.getUsersAsAdmin?.pageInfo?.hasNextPage
    ) {
      setFetchingMore(true);

      fetchMore({
        variables: {
          first: 20,
          after: data?.getUsersAsAdmin?.pageInfo?.endCursor,
        },
      }).finally(() => {
        setFetchingMore(false);
      });
    }
  }

  return {
    refs: {
      fetchMoreRef,
    },
    models: {
      loading,
      data: data?.getUsersAsAdmin?.edges,
    },
  };
}

export default useUsersContainer;
